var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback, useEffect, useState } from 'react';
import { useJSPositioning } from '#hooks';
/**
 * Wrapper around useJSPositioning() with specifics tailored for the FloatingBox case
 */
export const useFloatingBox = ({ contentOffset, placement, shouldCloseFloatingBox, shouldOpenFloatingBox, }) => {
    _react_refresh_temp_1();
    const [isFloatingBoxActive, setIsFloatingBoxActive] = useState(false);
    const { context, targetProps, triggerProps } = useJSPositioning({
        open: isFloatingBoxActive,
        onOpenChange: setIsFloatingBoxActive,
        strategy: 'fixed',
        ...(placement ? { placement } : {}),
        ...(contentOffset ? { contentOffset: contentOffset } : {}),
    });
    const closeFloatingBox = useCallback(() => setIsFloatingBoxActive(false), []);
    const openFloatingBox = useCallback(() => setIsFloatingBoxActive(true), []);
    useEffect(() => {
        if (shouldCloseFloatingBox) {
            closeFloatingBox();
        }
    }, [closeFloatingBox, shouldCloseFloatingBox]);
    useEffect(() => {
        if (shouldOpenFloatingBox) {
            openFloatingBox();
        }
    }, [openFloatingBox, shouldOpenFloatingBox]);
    return {
        context,
        closeFloatingBox,
        floatingBoxProps: targetProps,
        setIsFloatingBoxActive,
        isFloatingBoxActive,
        triggerProps,
    };
};
_react_refresh_temp_1(useFloatingBox, "UfF57EcanMhwfJgcdYWk0910LpM=", false, () => [useJSPositioning]);
